import { ChangeJobRequest, JobBase, JobReview, JobStatus, Work, EStoreExecutorTable } from '@project/shared-types';
import { ellipsisString } from '../../../hooks/ellipsisString';
import { TimeStampToStringDate } from '../../../hooks/timestamp_to_string_date';
import { sendError } from '../../../shared/hooks/sendTack';
import { JobRenderInfo } from '../job.types';
import { JobChangeAPI } from './job.api';



export class JobService {


    static async changeJobApi(
        job: JobBase,
        text: string | undefined,
        date: number,
        keywords?: string[],
        file_ids?: (string | undefined)[]
    ): Promise<JobBase | null> {
        try {
            const requestData = {
                order_id: job.order_id,
                job_id: job.id,
                text,
                date_public: date,
                keywords,
                file_ids: file_ids ?? [],
            } as ChangeJobRequest;
            const response = await JobChangeAPI(requestData);
            if (!response.job) {
                throw new Error("Не удалось изменить карточку услуги", { cause: response });
            }
            return response.job as JobBase;
        } catch (error) {
            sendError(error as Error);
            return null;
        }
    }

    static canEditJob(status: JobStatus) {
        return [JobStatus.DO, JobStatus.NO_WORK].includes(status);
    }

    static canFeedback(status: JobStatus) {
        return [JobStatus.CLOSE, JobStatus.WAIT_PAY, JobStatus.WAIT_CHECK].includes(status);
    }

    static getTextFromJob(job: JobReview) {
        return job.properties.text || ""
    }
    static getKeywordsFromJob(job: JobReview) {
        return job.properties.keywords || []
    }

    static getInfoForRender(job: JobReview, work?: Work): JobRenderInfo[] {
        if (!work) {
            if (job.status == JobStatus.DO) {
                return [
                    {
                        title: "Запланировано:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    {
                        title: "Ваш текст:",
                        text: ellipsisString(job.properties.text || "Не указан, будет написан исполнителем", 100),
                    },
                ];
            }
            if (job.status == JobStatus.NO_WORK) {
                return [
                    {
                        title: "Запланировано:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    {
                        title: "Ваш текст:",

                        text: ellipsisString(job.properties.text || "Не указан, будет написан исполнителем", 100),
                    },
                ];
            }
            return []
        }
        else {
            const methods: Record<JobStatus, () => JobRenderInfo[]> = {
                [JobStatus.DO]: () => [
                    {
                        title: "Запланировано:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    {
                        title: "Ваш текст:",
                        text: JobService.smallText(job.properties.text),
                    },
                ],
                [JobStatus.WORK]: () => [
                    {
                        title: "Выполняет:",
                        text: work.nickname ? work.nickname : "Скоро укажет",
                    },
                    {
                        title: "Начал:",
                        text: TimeStampToStringDate(work.date_published),
                    },
                    {
                        title: "Ваш текст:",
                        text: JobService.smallText(job.properties.text),
                    },
                ],
                [JobStatus.WAIT_CHECK]: () => [
                    {
                        title: "Имя на платформе:",
                        text: work.nickname ? work.nickname : "Скоро укажет",
                    },
                    {
                        title: "Текст исполнителя:",
                        text: JobService.smallText(work.text),
                    },
                    {
                        title: "Ваш текст:",
                        text: JobService.smallText(job.properties.text),
                    },
                    {
                        title: "Скриншот исполнителя:",
                        image: work.image,
                    },
                    {
                        title: "Дата выполнения:",
                        text: TimeStampToStringDate(work.date_published),
                    },
                ],
                [JobStatus.WAIT_PAY]: () => [
                    {
                        title: "Имя на платформе:",
                        text: work.nickname ? work.nickname : "Скоро укажет",
                    },
                    {
                        title: "Текст исполнителя:",
                        text: JobService.smallText(work.text),
                    },
                    {
                        title: "Ваш текст:",
                        text: JobService.smallText(job.properties.text),
                    },
                    {
                        title: "Скриншот исполнителя:",
                        image: work.image,
                    },
                    {
                        title: "Дата выполнения:",
                        text: TimeStampToStringDate(work.date_published),
                    },
                ],
                [JobStatus.CLOSE]: () => [
                    {
                        title: "Отправлено на проверку:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    {
                        title: "Скриншот исполнителя:",
                        image: work.image,
                    },
                    {
                        title: "Ваш текст:",
                        text: JobService.smallText(job.properties.text),
                    },
                    {
                        title: "Текст исполнителя:",
                        text: JobService.smallText(work.text),
                    },
                ],
                [JobStatus.NO_HOLD]: () => [],
                [JobStatus.NO_FIND_REVIEW]: () => [],
                [JobStatus.WAIT_CHECK2]: () => [],
                [JobStatus.NO_WORK]: () => [],
                [JobStatus.DELETE]: () => [],
            };

            return methods[job.status]?.() || [];
        }
    };

    static getInfoForRenderSub(job: JobBase, work?: Work): JobRenderInfo[] {
        if (work) {
            const methods: Record<JobStatus, () => JobRenderInfo[]> = {
                [JobStatus.DO]: () => [
                    {
                        title: "Запланировано:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                ],
                [JobStatus.WORK]: () => [
                    {
                        title: "Выполняет:",
                        text: work.nickname ? work.nickname : "Скоро укажет",
                    },
                    {
                        title: "Начал:",
                        text: TimeStampToStringDate(work.date_published),
                    },
                ],
                [JobStatus.WAIT_CHECK]: () => [
                    {
                        title: "Отправлено на проверку:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    { title: "Скриншот исполнителя:", image: work.image },
                ],
                [JobStatus.WAIT_PAY]: () => [
                    {
                        title: "Отправлено на проверку:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    { title: "Скриншот исполнителя:", image: work.image },
                ],
                [JobStatus.CLOSE]: () => [
                    {
                        title: "Отправлено на проверку:",
                        text: TimeStampToStringDate(job.date_public),
                    },
                    { title: "Скриншот исполнителя:", image: work.image },
                ],
                [JobStatus.NO_HOLD]: () => [],
                [JobStatus.NO_FIND_REVIEW]: () => [],
                [JobStatus.WAIT_CHECK2]: () => [],
                [JobStatus.NO_WORK]: () => [],
                [JobStatus.DELETE]: () => [],
            }
            return methods[job.status]?.() || []
        }
        return [
            {
                title: "Запланировано:",
                text: TimeStampToStringDate(job.date_public),
            },
        ]
    }
    private static smallText(text?: string) {
        return ellipsisString(text || "Не указан", 100)
    }

    static getWorkImageUrl(image: string, jobId?: number) {
        if (image.includes("jobs")) {
            return jobId ? `/${image}` : image
        }
        if (jobId) {
            return `/media/content/${EStoreExecutorTable.WORKS}/${jobId}/${image}`
        }
        return `/media/content/${EStoreExecutorTable.WORKS}/${image}`
    }
}